export const Role = {
  Admin: 'ADM',
  Organization: 'ORG'
}
